import Api from '../services/Api';
import { ErrorDictionary } from '../pages/Components/Helpers/ErrorDictionary';
import { ContaBancariaRequest, Response } from './Types';

class ContaBancariaController {
  public static async Listar(request: ContaBancariaRequest): Promise<Response> {
    try {
      console.log('Controller Conta Bancaria Listar');
      console.log(request);

      const response = await Api.post(`api/contabancaria/Listar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async ListarUnico(ContaBancariaId: number): Promise<Response> {
    try {
      console.log('Controller CondicaoPagamento Listar Unico');
      console.log(ContaBancariaId);

      const response = await Api.get(
        `api/contabancaria/ListarUnico/${ContaBancariaId}`
      );

      const object = response?.data;

      const retorno: Response = {
        StatusCode: response.status,
        Data: object[0],
      };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  /**
   * Conta marcada como conta de emissão de boleto.
   *
   * Devolve sempre uma linha. `temContaEmissao === false` (com o resto nulo) significa que
   * nenhuma conta está marcada — nesse caso a emissão de boleto tem de ser bloqueada com
   * mensagem clara. `ctb_codigoBanco` ('001' Banco do Brasil, '756' Sicoob) é o campo que
   * decide qual integração será usada na geração.
   */
  public static async EmissaoVigente(): Promise<Response> {
    try {
      const response = await Api.get(`api/contabancaria/EmissaoVigente`);

      const retorno: Response = {
        StatusCode: response.status,
        Data: response?.data,
      };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Adicionar(
    request: ContaBancariaRequest
  ): Promise<Response> {
    try {
      const response = await Api.post(`api/contabancaria/Adicionar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
        Message: error?.response?.data?.ErroDetalhado || error?.response?.data?.Erro
      };
      return retorno;
    }
  }

  public static async Atualizar(
    request: ContaBancariaRequest
  ): Promise<Response> {
    try {
      const response = await Api.put(`api/contabancaria/Atualizar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
        Message: error?.response?.data?.ErroDetalhado || error?.response?.data?.Erro
      };
      return retorno;
    }
  }

  public static async Excluir(
    request: ContaBancariaRequest
  ): Promise<Response> {
    try {
      console.log('Controller Conta Banc�ria Excluir');
      console.log(request);

      const response = await Api.put(`api/contabancaria/Excluir`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }
}

export default ContaBancariaController;
